import { Typography } from "@shared/ui.primitives";
import React from "react";

import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "brandName">;
};

export const VerticalProductCardBrandName: React.FC<Props> = ({ product }) => {
  return (
    <Typography variant="franchise-md" colour="primary-dark">
      {/* Non-breaking space to maintain layout height when no brand name */}
      {product?.brandName || "\u00A0"}
    </Typography>
  );
};
